export class UrlSearchParams {
    constructor(search) {
        this.search = search;
    }

    getParams() {
        if (!this.search) {
            return { };
        }

        return (/^[?#]/.test(this.search) ? this.search.slice(1) : this.search)
            .split('&')
            .reduce((params, param) => {
                let [ key, value ] = param.split('=');
                params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                return params;
            }, { });
    };
}


// WEBPACK FOOTER //
// ./src/utils/UrlSearchParams.js